export default {"src":"/planos/_next/static/media/equifax-restricted-access.3745b234.svg","height":37,"width":43,"blurWidth":0,"blurHeight":0};